import { useEffect, useState } from "react";
import axios from "../../../../requests/axios";
import routes from "../../../../requests/routes";
import Loader from "../../../../layouts/loader/Loader";
import UserCard from "../userCard/UserCard";
import classes from "./Wishlist.module.scss";

export const Wishlist = ({ record }) => {
  const wishlist = record.wishlist;
  const [adminPrograms, setAdminPrograms] = useState([]);
  const [loader, setLoader] = useState(true);

  async function getPrograms() {
    try {
      const response = await axios.get(routes.getAdminPrograms);
      setAdminPrograms(response.data.programs);
      setLoader(false);
    } catch (err) {}
  }
  useEffect(() => {
    getPrograms();
  }, []);

  const wishIdSet = new Set(wishlist.map(String)); // normalize
  const wishedPrograms = adminPrograms.filter((p) =>
    wishIdSet.has(String(p._id ?? p.id))
  );

  return (
    <>
      <div className={classes.cards}>
        {loader ? (
          <Loader color={"#F46444"} />
        ) : (
          wishedPrograms.map((wl, index) => <UserCard key={index} user={wl} />)
        )}
      </div>
    </>
  );
};
